"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSelectedDailyOfKind = void 0;
const core_1 = require("../../../core");
const getSelectedDailyOfKind = (dailyOfKind, t) => {
    const map = new Map([
        [
            core_1.DAILY_OF_KIND.everyday,
            t('configurationBackup|currentConfiguration|form|fields|dailyBackupOptions|dailyOfKind|everyday'),
        ],
        [
            core_1.DAILY_OF_KIND.weekdays,
            t('configurationBackup|currentConfiguration|form|fields|dailyBackupOptions|dailyOfKind|weekdays'),
        ],
        [
            core_1.DAILY_OF_KIND.selectedDays,
            t('configurationBackup|currentConfiguration|form|fields|dailyBackupOptions|dailyOfKind|selectedDays'),
        ],
    ]);
    return map.get(dailyOfKind) || '';
};
exports.getSelectedDailyOfKind = getSelectedDailyOfKind;
//# sourceMappingURL=getSelectedDailyOfKind.js.map